import { ThermometerLinesIcon } from './ThermometerLinesIcon';

/**
 * author: Austin Andrews
 * id A9FC898C-8CC5-44F2-822D-05C5625E95C8
 * name thermometer-lines
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-lines.svg
 * tags
 * - Weather 
 * - Home Automation 
 */
export const TemperatureLinesIcon = ThermometerLinesIcon;
export default TemperatureLinesIcon